import Vue from 'vue'

const defaultFormState = {
  success: false,
  fields: {},
  apiErrors: {
    other: []
  },
  saving: false
}

const initializeFormState = (fields) => {
  const initialState = JSON.parse(JSON.stringify(defaultFormState))

  for (let i=0; i<fields.length; i++) {
    const field = fields[i]
    initialState.fields[field] = null
    initialState.apiErrors[field] = []
  }

  return initialState
}

export const createForm = (fields) => ({
  namespaced: true,

  state: JSON.parse(JSON.stringify(
    initializeFormState(fields)
  )),

  mutations: {
    setField(state, {field, value}) {
      Vue.set(state.fields, field, value)
      Vue.set(state.apiErrors, field, [])

      // TODO this function is called when resetFields fx runs?
      // only reset success if setField is not being called to reset a field
      if (value !== null) {
        Vue.set(state, 'success', false)
      }
    },

    setErrors(state, errors) {
      const errorKeys = Object.keys(errors)
      for (let i=0; i<errorKeys.length; i++) {
        const errorKey = errorKeys[i]
        if (state.apiErrors.hasOwnProperty(errorKey)) {
          Vue.set(state.apiErrors, errorKey, errors[errorKey])
        }
      }
    },

    setFieldErrors(state, {field, errors}) {
      state.apiErrors[field] = errors
    },

    setSuccess(state, success) {
      Vue.set(state, 'success', success)
    },

    setSaving(state, saving) {
      Vue.set(state, 'saving', saving)
    },

    resetSuccess(state) {
      Vue.set(state, 'success', false)
    },

    resetFields(state) {
      for (const prop in state.fields) {
        Vue.set(state.fields, prop, null)
      }
    },

    resetErrors(state) {
      for (const prop in state.apiErrors) {
        Vue.set(state.apiErrors, prop, [])
      }
    },

    resetState(state) {
      state.success = false
      for (const prop in state.fields) {
        Vue.set(state.fields, prop, null)
      }
      for (const prop in state.apiErrors) {
        Vue.set(state.apiErrors, prop, [])
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/factories/index.js